import React, { useState }  from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

const PAGE_SIZE = 100;

const MontosTableLibroVentas = ({ montos }) => {
  const [page, setPage] = useState(0);

  const totalPages = Math.ceil(montos.length / PAGE_SIZE);
  const start = page * PAGE_SIZE;
  const visibleMontos = montos.slice(start, start + PAGE_SIZE);

  return (
    <div style={{ padding: "20px", backgroundColor: "#f9f9f9", borderRadius: "8px", boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)" }}>
      <h4 style={{ color: "#856404", marginBottom: "15px", fontSize: "18px", fontWeight: "600" }}>
        Montos a cargar ({montos.length} registros):
      </h4>
      <table style={{ width: "100%", borderCollapse: "collapse", backgroundColor: "#fff", borderRadius: "8px", overflow: "hidden" }}>
        <thead>
          <tr style={{ backgroundColor: "#e9ecef", borderBottom: "2px solid #ddd" }}>
            <th style={{ padding: "12px", textAlign: "left", fontSize: "16px", color: "#4a4a4a", fontWeight: "500" }}>Registro</th>
            <th style={{ padding: "12px", textAlign: "left", fontSize: "16px", color: "#4a4a4a", fontWeight: "500" }}>Monto</th>
          </tr>
        </thead>
        <tbody>
          {visibleMontos.map((monto, i) => (
            <tr key={start + i} style={{ borderBottom: "1px solid #ddd" }}>
              <td style={{ padding: "12px", fontSize: "16px", color: "#4a4a4a", textAlign: "left" }}>
                Registro {start + i + 1}
              </td>
              <td style={{ padding: "12px", fontSize: "16px", color: "#4a4a4a", textAlign: "left" }}>
                <NumberFormat
                  value={monto}
                  displayType={'text'}
                  thousandSeparator='.'
                  decimalSeparator=','
                  decimalScale={2}
                  fixedDecimalScale={false}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {totalPages > 1 && (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "12px", marginTop: "15px" }}>
          <button
            type="button"
            onClick={() => setPage((p) => Math.max(0, p - 1))}
            disabled={page === 0}
          >
            Anterior
          </button>
          <span style={{ fontSize: "14px", color: "#4a4a4a" }}>
            Página {page + 1} de {totalPages}
          </span>
          <button
            type="button"
            onClick={() => setPage((p) => Math.min(totalPages - 1, p + 1))}
            disabled={page === totalPages - 1}
          >
            Siguiente
          </button>
        </div>
      )}
    </div>
  );
};

MontosTableLibroVentas.propTypes = {
  montos: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default MontosTableLibroVentas;